import gql from 'graphql-tag';
import { VotingAreaFields } from 'src/graphql/voting_areas/queries';

export const CampaignVotingAreaFields = gql`
  fragment CampaignVotingAreaFields on ri_apps_prd_campaign_voting_areas {
    campaign_voting_area_id
    campaign_id
    voting_area_id
    campaign_voting_areas_voting_area {
      ...VotingAreaFields
    }
  }
  ${VotingAreaFields}
`;

export const GET_CAMPAIGN_VOTING_AREAS = gql`
  query getCampaignVotingAreas($campaignId: Int!) {
    rows: ri_apps_prd_campaign_voting_areas(where: { campaign_id: { _eq: $campaignId } }) {
      ...CampaignVotingAreaFields
    }
  }
  ${CampaignVotingAreaFields}
`;

export const GET_ORGANIZATION_VOTING_AREAS = gql`
  query getOrganizationVotingAreas($organizationId: Int!) {
    rows: ri_apps_prd_organization_voting_areas(
      where: { organization_id: { _eq: $organizationId } }
      order_by: [{ organization_voting_areas_voting_area: { state_id: asc_nulls_last } }]
    ) {
      voting_area_id
      organization_voting_areas_voting_area {
        ...VotingAreaFields
      }
    }
  }
  ${VotingAreaFields}
`;

export const UPSERT_CAMPAIGN_VOTING_AREAS = gql`
  mutation UpsertCampaignVotingAreas($data: [ri_apps_prd_campaign_voting_areas_insert_input!]!) {
    rows: insert_ri_apps_prd_campaign_voting_areas(objects: $data) # on_conflict: {
    #   constraint: campaign_voting_areas_pkey
    #   update_columns: [voting_area_id, campaign_id]
    # }
    {
      affected_rows
    }
  }
`;

export const DELETE_CAMPAIGN_VOTING_AREAS = gql`
  mutation DeleteCampaignVotingAreas($campaignId: Int!, $votingAreaIds: [Int!]!) {
    rows: delete_ri_apps_prd_campaign_voting_areas(
      where: { campaign_id: { _eq: $campaignId }, voting_area_id: { _in: $votingAreaIds } }
    ) {
      affected_rows
    }
  }
`;
